import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import awsExports from "./aws-exports";
import mapboxgl from "mapbox-gl";
import { observer } from "mobx-react";
import { AuthenticatorView } from "./app/auth/views/AuthenticatorView";
import { SharedSurveyMapPage } from "./app/pages/map/SharedSurveyMapPage";
import { DemonstratorPage } from "./app/demonstrator/DemonstratorPage";
import { CommentRedirectPage } from "./app/pages/comment/CommentRedirectPage";
import { AdminIntegrationsPage } from "./app/admin/views/integrations/AdminIntegrationsPage";
import { AccountHomePage } from "./app/account/views/home/AccountHomePage";
import { AccountUsersPage } from "./app/account/views/users/AccountUsersPage";
import { AccountSurveysPage } from "./app/account/views/surveys/AccountSurveysPage";
import { AccountIntegrationsPage } from "./app/account/views/integrations/AccountIntegrationsPage";
import { AdminToolsPage } from "./app/admin/views/tools/AdminToolsPage";
import { useStores } from "./app/shared/stores/RootStore";
import { AdminSurveysPage } from "./app/admin/views/surveys/AdminSurveyPage";
import { MapPage } from "./app/pages/map/MapPage";
import { CraWayRedirectPage } from "./app/cra/views/CraWayRedirectPage";
import { AdminUsersPage } from "./app/admin/views/users/AdminUsersPage";
import { AdminAccountsPage } from "./app/admin/views/accounts/AdminAccountsPage";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_KEY!;

Amplify.configure(awsExports as any);

export const appRoutes = {
  home: () => `/`,
  survey: (id = ":surveyId") => `/survey/${id}`,
  comment: (id = ":commentId") => `/comment/${id}`,
  craWay: (id = ":craWayId") => `/cra-way/${id}`, // TODO add page to redirect this to the survey page
  account: (id = ":accountId") => `/account/${id}`,
  accountUsers: (id = ":accountId") => `/account/${id}/users`,
  accountSurveys: (id = ":accountId") => `/account/${id}/surveys`,
  accountIntegrations: (id = ":accountId") => `/account/${id}/integrations`,
  demonstrator: () => `/demonstrator`,
  admin: () => `/admin`,
  adminIntegrations: () => `/admin/integrations`,
  adminTools: () => `/admin/tools`,
  adminSurveys: () => `/admin/surveys`,
  adminUsers: () => `/admin/users`,
  adminAccounts: () => `/admin/accounts`,
};

export const publicRoutes = {
  survey: (id = ":surveyId") => `/shared/survey/${id}`,
  signUp: () => "/sign-up",
};

function App() {
  const { authStore } = useStores();

  return (
    <BrowserRouter>
      <Routes>
        {authStore.isAuthenticated ? (
          <>
            <Route index element={<MapPage isHome />} />
            <Route path={appRoutes.survey()} element={<MapPage />} />
            <Route
              path={appRoutes.demonstrator()}
              element={<DemonstratorPage />}
            />
            <Route
              path={appRoutes.comment()}
              element={<CommentRedirectPage />}
            />
            <Route path={appRoutes.craWay()} element={<CraWayRedirectPage />} />

            {/* Account backoffice */}
            <Route path={appRoutes.account()} element={<AccountHomePage />} />
            <Route
              path={appRoutes.accountUsers()}
              element={<AccountUsersPage />}
            />
            <Route
              path={appRoutes.accountSurveys()}
              element={<AccountSurveysPage />}
            />
            <Route
              path={appRoutes.accountIntegrations()}
              element={<AccountIntegrationsPage />}
            />

            {/* SuperAdmin backoffice */}
            {authStore.isSuperAdmin && (
              <>
                <Route path={appRoutes.admin()} element={<AdminToolsPage />} />
                <Route
                  path={appRoutes.adminTools()}
                  element={<AdminToolsPage />}
                />
                <Route
                  path={appRoutes.adminIntegrations()}
                  element={<AdminIntegrationsPage />}
                />
                <Route
                  path={appRoutes.adminSurveys()}
                  element={<AdminSurveysPage />}
                />
                <Route
                  path={appRoutes.adminUsers()}
                  element={<AdminUsersPage />}
                />
                <Route
                  path={appRoutes.adminAccounts()}
                  element={<AdminAccountsPage />}
                />
              </>
            )}
          </>
        ) : (
          <>
            <Route path="*" element={<AuthenticatorView />} />
          </>
        )}

        {/* Routes to resources shared by the user */}
        <Route
          path={publicRoutes.survey()}
          element={<SharedSurveyMapPage />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default observer(App);
